import { UNFOLLOW_CATEGORY } from '../../../constants/interactions';
import { CATEGORY_UNSUBSCRIBED } from '../../messages/message-types';
import { unsubscribe } from '../../../actions/unsubscribe';

export const unfollowCategoryModalResolver =
  (categoryId, { showMessage }) =>
  (dispatch, getState, { panoramaClient }) => {
    panoramaClient.transaction(UNFOLLOW_CATEGORY).start();
    return dispatch(unsubscribe({ _id: categoryId, type: 'category' })).then(() => {
      panoramaClient.transaction(UNFOLLOW_CATEGORY).end();
      return showMessage(CATEGORY_UNSUBSCRIBED);
    });
  };
